module.exports = __webpack_public_path__ + "img/seminar (5).46df27da.jpg";